import { render, staticRenderFns } from "./HomeRight.vue?vue&type=template&id=230a7d4c&scoped=true"
import script from "./HomeRight.vue?vue&type=script&lang=js"
export * from "./HomeRight.vue?vue&type=script&lang=js"
import style0 from "./HomeRight.vue?vue&type=style&index=0&id=230a7d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.99.9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a7d4c",
  null
  
)

export default component.exports